import { createFileRoute } from '@tanstack/react-router'
import InvalidLinkError from '@/features/error/InvalidLinkError'

export const Route = createFileRoute('/_main/invalid-link')({
  component: InvalidLinkError,
})
